const CONVERSION_DESTINATION = "AW-18487585801/7cBeCOWko40dEInYyO9E";

export const reportContactConversion = () => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: CONVERSION_DESTINATION });
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
};
